import React from 'react'
import TravelInquiry from '@commons/bookings/travel-inquriy'

const UserTravelInquiry = ({ user }) => {
  return <TravelInquiry user={user} />
}

export default UserTravelInquiry
